export default __webpack_public_path__ + "static/media/isuzu.4c95500e.webp";